import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ApiDeleteReportMessage,
  ApiGetRegionBusinessDetails,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";

const RegionBusinessDetails: React.FC = () => {
  const [regionBusinessDetail, setRegionBusinessDetails] = useState([]);

  const fetchRegionBusinessDetails = async () => {
    try {
      const response = await ApiGetRegionBusinessDetails();
      setRegionBusinessDetails(response.data);
    } catch (error) {
      console.error("Error fetching area managers:", error);
    }
  };

  useEffect(() => {
    fetchRegionBusinessDetails();
  }, []);

  const navigate = useNavigate();

  const addOrUpdateRegionBusinessDetails = (reportBusinessDetails?: any) => {
    if (reportBusinessDetails) {
      navigate(
        `/admin/add-or-update-regionBusinessDetail/update/${reportBusinessDetails.clientEntityRegionReportId}`,
        {
          state: { reportBusinessDetails: reportBusinessDetails },
        }
      );
    } else {
      navigate("/admin/add-or-update-regionBusinessDetail/add");
    }
  };

  const handleDelete = async (clientEntityRegionReportId: number) => {
    const data = `?clientEntityRegionReportId=${clientEntityRegionReportId}`;
    try {
      const response = await ApiDeleteReportMessage(data);
      toast.success("Report Message deleted successfully");
      fetchRegionBusinessDetails();
    } catch (error) {
      console.error("Error deleting brief:", error);
      toast.error("Failed to delete brief");
    }
  };

  return (
    <div className="manage-admin-container">
      <div className="manage-button">
        <h1 className="common-manage-h1">Region Business Details</h1>
        <div className="add-button common-manage-button">
          <Button
            variant="contained"
            onClick={() => addOrUpdateRegionBusinessDetails()}
            className="table-row-background "
          >
            Add Region Business Detail
          </Button>
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow className="table-row-background">
            {["", "Region", "Business", ""].map((item) => (
              <TableCell style={{ color: "#fff" }}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {regionBusinessDetail.map((details: any) => (
            <TableRow key={details.clientEntityRegionReportId}>
              <TableCell>
                <Button
                  variant="contained"
                  className="delete-transparent"
                  onClick={() => {
                    const isConfirmed = window.confirm(
                      "Are you sure you want to delete?"
                    );
                    if (isConfirmed) {
                      handleDelete(details.clientEntityRegionReportId); // Call the API or action
                    }
                  }}
                >
                  <DeleteIcon className="delete-icon" />
                </Button>
              </TableCell>
              <TableCell>{details.regionId.regionName}</TableCell>
              <TableCell>{details.clientEntityId.entityName}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => addOrUpdateRegionBusinessDetails(details)}
                  className="table-row-background"
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RegionBusinessDetails;
